// src/modules/app-views/_apps/appmulti/orders/pages/Init/components/OrdersPreviewHeader/index.jsx
import { Divider, Flex, Tag, Typography, theme } from 'antd';
import translateX from 'utils/translateX';
import financialService from 'services/financialService';
import app from 'configs/ConfigIndex';

const { Text, Title } = Typography;

const dividerStyle = { margin: '24px 0 16px' };
const titleStyle = { marginBottom: 4 };
const tagWrapStyle = { marginBottom: 8 };
const fieldsWrapStyle = { marginTop: 16 };
const labelStyle = { fontSize: 13 };
const valueStyle = { fontSize: 13 };

const OrdersPreviewHeader = ({ selectedDocument: r }) => {
  const { token } = theme.useToken();
  const baseColor = app?.baseColor || token.colorPrimary;
  const bgBarStyle = {
    height: 56,
    marginLeft: -24,
    marginRight: -24,
    marginTop: -24,
    marginBottom: 20,
    backgroundColor: baseColor,
  };

  if (!r) return null;

  const buyerName = r?.__buyer?.name || r?.__buyer?.fullName;
  const sellerName = r?.__seller?.name;
  const value = r?.totalInOrderDate?.totalToPay;
  const formattedValue =
    value != null
      ? `R$ ${financialService.formatNumber(value, { decimals: 2, locale: 'pt-BR' })}`
      : null;

  return (
    <div>
      <div style={bgBarStyle} />
      <div style={{ textAlign: 'center' }}>
        {r?.status && (
          <div style={tagWrapStyle}>
            <Tag color="blue">{translateX(r.status)}</Tag>
          </div>
        )}
        <Title level={4} style={titleStyle}>
          {buyerName || r?.name || '—'}
        </Title>
        <div style={fieldsWrapStyle}>
          <Flex vertical gap={4} style={{ width: '100%' }}>
            {r?.__buyer?.email && (
              <InfoRow label={translateX('email')} value={r.__buyer.email} token={token} />
            )}
            {r?.destiny && (
              <InfoRow
                label={translateX('destiny')}
                value={translateX(r.destiny)}
                token={token}
              />
            )}
            {formattedValue && (
              <InfoRow label={translateX('value')} value={formattedValue} token={token} strong />
            )}
            <InfoRow
              label={translateX('seller')}
              value={sellerName || translateX('online_sale')}
              token={token}
            />
          </Flex>
        </div>
        <Divider style={dividerStyle} />
      </div>
    </div>
  );
};

export default OrdersPreviewHeader;

function InfoRow({ label, value, token, strong = false }) {
  if (!value) return null;
  const rowStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 0',
    borderBottom: `1px solid ${token?.colorBorderSecondary}`,
  };
  return (
    <div style={rowStyle}>
      <Text type="secondary" style={labelStyle}>
        {label}:
      </Text>
      <Text strong={strong} style={valueStyle}>
        {value}
      </Text>
    </div>
  );
}
